import { Product, ServerProduct } from '../../typings/products';

export const mapInternalProductFromApi = (product: ServerProduct): Product => ({
    id: String(product.productId),
    productName: product.productName,
    productLogin: product.productLogin,
    description: product.productDescription,
    productAccess: product.productAccess,
    productPlaceIds: product.productPlaceIds,
    isSaved: true,
    ulogin: product.productLogin
});
